import { identifyAnalyticsUser } from '@backoffice-frontend/tracking'
import { useBackofficeLoggedInUser } from '@backoffice-frontend/user-management-ui'
import { useEffect } from 'react'

export const useAnalyticsIdentity = () => {
  const { user } = useBackofficeLoggedInUser()

  useEffect(() => {
    if (user) {
      identifyAnalyticsUser(user.id, user.organizationId)
    }
  }, [user])
}
